import React, { useEffect, useState } from 'react';
import { TextField, Box, Button, Modal, Typography } from '@mui/material';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { withTranslation } from 'react-i18next';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 450,
  height: 'auto',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 2,
  borderRadius: '10px'
};

function AddMessageModal(props) {
  const [isLoading, setIsLoading] = useState(false)

  function toggleModal() {
    removeBodyCss();
    props?.handleNoteModalToggle(null, null)
  }

  const formik = useFormik({
    initialValues: { message: '' },
    validationSchema: Yup.object({
      message: Yup.string().strict(true).trim('Leading and trailing spaces is not allowed.').required('Please enter message.'),
    }),
    validateOnMount: true,
  })

  function removeBodyCss() {
    document.body.classList.add('no_padding');
  }

  return (
    <div>

      {/* ========= Modal To create/edit note ===========  */}
      <Modal
        open={props.isOpen}
        disableScrollLock={true}
        onClose={props.handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"

      >
        <Box sx={style}>
          <Typography id="modal-modal-title">
            <b>{props.t('Send message to all user that is involved in selected startups')}</b>
          </Typography>
          <div className='mt-4'>
            <TextField
              label='Message'
              fullWidth
              name='message'
              disabled={isLoading}
              value={formik.values.message}
              multiline
              rows={6}
              variant="outlined"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              required
            />
            {
              formik.touched?.message && formik.errors?.message && <div className='text-danger mt-2'>{formik.errors.message}</div>
            }
          </div>
          <div className="projApprovalbtns mt-3 modal_footer text-center">
            <Button
              variant="outlined"
              className="approveBtn mx-2"
              type="submit"
              onClick={() => props.handleSubmit(formik.values.message)}
              disabled={!formik.isValid}
            >
              {props.t('Send Message')}
            </Button>
            <Button
              disableElevation
              variant="contained"
              className="cancelBttn mx-2"
              type="reset"
              onClick={props.handleClose}
            >
              {props.t('Cancel')}
            </Button>
          </div>
        </Box>
      </Modal>
    </div>
  );
}

export default withTranslation()(AddMessageModal)